/**
 * Renders card rules text with inline icons for :rb_might:, :rb_power:, etc.
 */

import { getCardTextSegments } from './cardUtils.js';
import { getTokenIconUrl } from './statIcons.js';

export default function CardTextWithIcons({ card, className, iconClass = 'card-text-inline-icon', size }) {
  const segments = getCardTextSegments(card);
  if (!segments.length) return <span className={className}>—</span>;

  const iconClassName = size === 'small' ? `${iconClass} ${iconClass}--small` : iconClass;

  return (
    <span className={className}>
      {segments.map((seg, i) => {
        if (seg.type === 'text') {
          return <span key={i}>{seg.value}</span>;
        }
        const url = getTokenIconUrl(seg.name);
        if (url) {
          return (
            <img
              key={i}
              src={url}
              alt={seg.label}
              className={iconClassName}
              aria-hidden
              title={seg.label}
            />
          );
        }
        return (
          <span key={i} className="card-text-token-fallback" title={seg.label}>
            [{seg.label}]
          </span>
        );
      })}
    </span>
  );
}
